<template>
  <!-- ------------------ 出行订单 ------------------ -->
  <div :label="table_list_itle" name="fourth">
    <el-table
      v-loading="listLoading"
      :data="bookingListData"
      class="all-booking"
      width="100%"
      :header-cell-style="{ background: '#F5F7FA', color: '#606266' }"
    >
      <el-table-column label=" 订单信息">
        <template slot-scope="activeinfo">
          <div style="font-size: 15px; font-weight: bold">
            {{ activeinfo.row.title }}
          </div>
          <div style="font-size: 13px">
            <i
              v-show="activeinfo.row.ex_product == '已匹配套餐'"
              style="color: green"
              class="el-icon-circle-check"
              :title="activeinfo.row.ex_product"
            ></i>
            <i
              v-show="activeinfo.row.ex_product != '已匹配套餐'"
              style="color: red"
              class="el-icon-circle-close"
              :title="activeinfo.row.ex_product"
            ></i>
            套餐：
            {{ activeinfo.row.package }}
          </div>
          <div style="font-size: 13px">数量：{{ activeinfo.row.num }}</div>
          <div style="font-size: 13px">
            参加日期：{{ activeinfo.row.trip_start_date }}
            <span
              v-show="activeinfo.row.total_fee"
              style="font-size: 10px; float: right"
            >
              平台付费：{{ activeinfo.row.total_fee }}元
            </span>
          </div>

          <div v-show="activeinfo.row.trip_start_time" style="font-size: 13px">
            时间/场次：{{ activeinfo.row.trip_start_time }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label=" 预定人信息" width="160%">
        <template slot-scope="contactinfo">
          <div class="resveration_contactor_infromation">
            <div>昵称： {{ contactinfo.row.nick }}</div>
            <div>联系人： {{ contactinfo.row.name }}</div>
            <div>电话： {{ contactinfo.row.phone }}</div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="订单信息" width="250%">
        <template slot-scope="bookinginfo">
          <div style="font-size: 13px">
            平台单号： {{ bookinginfo.row.ota_id }}
          </div>
          <div style="font-size: 13px">
            下单日期：{{ bookinginfo.row.created_date }}
          </div>
          <div style="font-size: 13px">
            平台订单状态：
            <span style="font-size: 13px; color: #ff5421">{{
              bookinginfo.row.status
            }}</span>
          </div>
          <div style="font-size: 13px">
            入库状态：
            <span
              v-if="bookinginfo.row.sys_status === true"
              style="font-size: 13px; color: red"
              >已删除</span
            >
            <span
              v-else-if="bookinginfo.row.sys_status === false"
              style="font-size: 13px; color: green"
            >
              已入库(ID:{{ bookinginfo.row.id }})</span
            >
            <span v-else style="font-size: 13px; color: #ff5421"
              >{{ bookinginfo.row.sys_status }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label=" 操作" align="center" width="180">
        <template slot-scope="bookinginfo">
          <el-button-group>
            <!-- 获取订单详情的 按钮,drawer=true, -->
            <el-button
              @click="openDrawer(bookinginfo.row.booking_no)"
              size="mini"
              :plain="true"
              disabled
              type="primary"
              >详细</el-button
            >
            <!-- 确认单 -->
            <el-button
              @click="getVoucher(bookinginfo.row.id)"
              size="mini"
              type="primary"
              :plain="true"
              icon="el-icon-document-checked"
            ></el-button>

            <!-- 绑定出行人 -->
            <el-button
              @click="selectBookingTraveller(bookinginfo.row.id)"
              size="mini"
              type="primary"
              :plain="true"
              icon="el-icon-s-custom"
            ></el-button>
          </el-button-group>

          <el-button-group style="margin-top: 5px">
            <!-- ---------处理订单---------- -->
            <el-button
              size="mini"
              @click="dealWithBooking(bookinginfo.row)"
              type="primary"
              icon="el-icon-message"
              >处理</el-button
            >
            <!-- ---------修改订单信息---------- -->
            <el-button
              size="mini"
              @click="reviseBooking(bookinginfo.row)"
              type="primary"
              icon="el-icon-document-copy"
              >修改</el-button
            >
          </el-button-group>
          <!-- 备注 -->
          <el-popover
            placement="left"
            title="备注"
            width="200"
            trigger="hover"
            :content="bookinginfo.row.booking_remark"
          >
            <el-button
              size="mini"
              class="remark_line_button"
              slot="reference"
              @click="reviseRemarkButton(bookinginfo.row.booking_no)"
              >备注：{{ bookinginfo.row.booking_remark }}</el-button
            >
          </el-popover>
          <!-- <div class="remark_line_div">
            <div
              style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >备注：{{bookinginfo.row.booking_remark}}</div>
          </div>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- ----------------- 分页 ------------------ -->
    <div class="pagination">
      <el-pagination
        @current-change="handleCurrentChange_system"
        :small="true"
        background
        layout="prev, pager, next, total"
        :current-page.sync="pagenum_system"
        :page-size="ota_page_size"
        :total="page_account"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "ota-booking-list-template",
  data() {
    return {
      bookinginfo: "",
      loading: this.listLoading,
      pagenum_system: 1, // 当前页
      ota_page_size: this.pagesize_ota,
      ota_total: 0,
      dialogReviseBooking: false, // 修改订单的对话框是否可见
    };
  },
  watch: {},
  props: {
    table_list_itle: "",
    bookingListData: Array,
    listLoading: Boolean,
    page_account: Number, // 总条数
    pagesize_ota: Number,
  },
  methods: {
    // 打开添加出行人对话框
    selectBookingTraveller(bookinginfo_booking_no) {
      this.$emit("selectBookingTraveller", bookinginfo_booking_no);
    },

    dealWithBooking(value) {
      this.$emit("dealWithBooking", value);
    },
    reviseBooking(item) {
      // this.bookinginfo = item;
      this.$emit("editBooking", item);
    },
    getVoucher(bookinginfo_booking_no) {
      this.$emit("getVoucher", bookinginfo_booking_no);
    },
    reviseRemarkButton(value) {},
    // 处理当前页的变动
    handleCurrentChange_system(val) {
      // console.log(`每页 ${val} 条`);
      this.$emit("handlePageChange_ota", val);
    },
  },
};
</script>

<style>
.num_join_traveller {
  width: 40%;
  margin-right: 5px;
  padding: 5px 10px;
  background-color: rgb(236, 236, 236);
  border-radius: 5px;
}

.resveration_contactor_infromation {
  padding: 10px 0px;
  font-size: 12px;
}
.remark_line_div {
  /* margin-top: 10px; */
  margin: 8px;
  /* border-top: 1px solid #ff5421; */
  border: 1px solid #ff5421;
  border-radius: 3px;
  font-size: 12px;
  padding-left: 10px;
  text-align: left;
  /* //溢出用省略号显示 */
}
.remark_line_button {
  margin: 8px;
  width: 90%;
  /* border-top: 1px solid #ff5421; */
  font-size: 12px;
  padding-left: 10px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #ff5421;
}
</style>